import { useId } from "react";
import type { EmployeeStatus } from "@/lib/api";
import { EMPLOYEE_STATUSES, STATUS_LABELS } from "@/lib/roster";
import { useListUrl } from "./use-list-url";

/** A checkbox kept in the URL as `param=true`. Changing it returns the lists
 *  it affects to page 1. */
export function UrlTickbox({ label, param, resets = ["page"] }: { label: string; param: string; resets?: string[] }): React.ReactElement {
  const [url, change] = useListUrl();
  return (
    <label className="flex items-center gap-2 text-sm text-gray-800">
      <input
        type="checkbox"
        checked={url.get(param) === "true"}
        onChange={(e) =>
          change({ [param]: e.target.checked ? "true" : null, ...Object.fromEntries(resets.map((p) => [p, null])) })
        }
      />
      {label}
    </label>
  );
}

/** The Stage dropdown: "All stages" or one of the nine stages, in plain language. */
export function StageFilter(): React.ReactElement {
  const id = useId();
  const [url, change] = useListUrl();
  return (
    <div className="flex items-center gap-2 text-sm">
      <label htmlFor={id} className="font-medium text-gray-800">
        Stage
      </label>
      <select
        id={id}
        value={url.get("stage") ?? ""}
        onChange={(e) => change({ stage: e.target.value === "" ? null : e.target.value, page: null })}
        className="rounded-md border border-gray-300 bg-white px-2 py-2 text-sm"
      >
        <option value="">All stages</option>
        {EMPLOYEE_STATUSES.map((s: EmployeeStatus) => (
          <option key={s} value={s}>
            {STATUS_LABELS[s]}
          </option>
        ))}
      </select>
    </div>
  );
}
